import { Divider } from '@mantine/core';
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    InputLabel,
    MenuItem,
    Select,
    SelectChangeEvent,
    TextField
} from '@mui/material';

type Props = {
    open: boolean;
    onClose: () => void;
    filters: any;
    onChange: (key: string, value: any) => void;
    onApply: () => void;
    onReset: () => void;
};

export default function BolFilterModal({
    open,
    onClose,
    filters,
    onChange,
    onApply,
    onReset,
}: Props) {
    // set up for approvals 

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
            <DialogTitle>Filters</DialogTitle>

            <DialogContent>
                <Box
                    sx={{
                        display: 'grid',
                        gridTemplateColumns: {
                            xs: '1fr',
                            sm: '1fr 1fr',
                        },
                        gap: 1.5,
                        pt: 2,
                    }}
                >
                    <TextField
                        label="Start Date"
                        type="date"
                        value={filters.start_date || ''}
                        InputLabelProps={{ shrink: true }}
                        onChange={(e) => onChange('start_date', e.target.value)}
                        fullWidth
                    />

                    <TextField
                        label="End Date"
                        type="date"
                        value={filters.end_date || ''}
                        InputLabelProps={{ shrink: true }}
                        onChange={(e) => onChange('end_date', e.target.value)}
                        fullWidth
                    />

                    <TextField
                        label="Shipper Name"
                        value={filters.shipper || ''}
                        onChange={(e) => onChange('shipper', e.target.value)}
                        fullWidth
                    />

                    <TextField
                        label="Receiver Name"
                        value={filters.receiver || ''}
                        onChange={(e) => onChange('receiver', e.target.value)}
                        fullWidth
                    />
                    <Divider/>
                    <Divider/>
                    <TextField
                        label="PO No."
                        value={filters.po_no || ''}
                        onChange={(e) => onChange('po_no', e.target.value)}
                        fullWidth
                    />

                    {/* <TextField
                        label="BOL No."
                        value={filters.bol_no || ''}
                        onChange={(e) => onChange('bol_no', e.target.value)}
                        fullWidth
                    /> */}

                    <TextField
                        label="Carrier"
                        value={filters.trailer || ''}
                        onChange={(e) => onChange('trailer', e.target.value)}
                        fullWidth
                    />

                    <TextField
                        label="Supplier"
                        value={filters.supplier || ''}
                        onChange={(e) => onChange('supplier', e.target.value)}
                        fullWidth
                    />

                    <TextField
                        label="Trailer No."
                        value={filters.info || ''}
                        onChange={(e) => onChange('info', e.target.value)}
                        fullWidth
                    />

                    <TextField
                        label="Invoice No."
                        value={filters.invoice_no || ''}
                        onChange={(e) => onChange('invoice_no', e.target.value)}
                        fullWidth
                    />

                    <FormControl fullWidth size="small">
                        <InputLabel id="vendor-delivered-label">Vendor Delivered</InputLabel>
                        <Select
                            labelId="vendor-delivered-label"
                            label="Vendor Delivered"
                            value={
                                filters.vendor_delivered === true
                                    ? 'true'
                                    : filters.vendor_delivered === false
                                        ? 'false'
                                        : ''
                            }
                            onChange={(e: SelectChangeEvent) =>
                                onChange(
                                    'vendor_delivered',
                                    e.target.value === ''
                                        ? null
                                        : e.target.value === 'true'
                                )
                            }
                        >
                            <MenuItem value="">All</MenuItem>
                            <MenuItem value="true">Delivered</MenuItem>
                            <MenuItem value="false">Pending</MenuItem>
                        </Select>
                    </FormControl>

                    <FormControl fullWidth size="small">
                        <InputLabel id="dc-received-label">DC Received</InputLabel>
                        <Select
                            labelId="dc-received-label"
                            label="DC Received"
                            value={
                                filters.dc_received === true
                                    ? 'true'
                                    : filters.dc_received === false
                                        ? 'false'
                                        : ''
                            }
                            onChange={(e: SelectChangeEvent) =>
                                onChange(
                                    'dc_received',
                                    e.target.value === ''
                                        ? null
                                        : e.target.value === 'true'
                                )
                            }
                        >
                            <MenuItem value="">All</MenuItem>
                            <MenuItem value="true">Received</MenuItem>
                            <MenuItem value="false">Pending</MenuItem>
                        </Select>
                    </FormControl>

                    <FormControl fullWidth size="small">
                        <InputLabel id="payment-status-label">Payment Status</InputLabel>
                        <Select
                            labelId="payment-status-label"
                            label="Payment Status"
                            value={
                                filters.payment_status === true
                                    ? 'true'
                                    : filters.payment_status === false
                                        ? 'false'
                                        : ''
                            }
                            onChange={(e: SelectChangeEvent) =>
                                onChange(
                                    'payment_status',
                                    e.target.value === ''
                                        ? null
                                        : e.target.value === 'true'
                                )
                            }
                        >
                            <MenuItem value="">All</MenuItem>
                            <MenuItem value="true">Paid</MenuItem>
                            <MenuItem value="false">Unpaid</MenuItem>
                        </Select>
                    </FormControl>

                    <FormControl fullWidth size="small">
                        <InputLabel id="approval-label">Approval</InputLabel>
                        <Select
                            labelId="approval-label"
                            label="Approval"
                            value={
                                filters.approved === true
                                    ? 'true'
                                    : filters.approved === false
                                        ? 'false'
                                        : ''
                            }
                            onChange={(e: SelectChangeEvent) =>
                                onChange(
                                    'approved',
                                    e.target.value === ''
                                        ? null
                                        : e.target.value === 'true'
                                )
                            }
                        >
                            <MenuItem value="">All</MenuItem>
                            <MenuItem value="true">Approved</MenuItem>
                            <MenuItem value="false">Pending</MenuItem>
                        </Select>
                    </FormControl>

                    <TextField
                        label="Type"
                        value={filters.type || ''}
                        onChange={(e) => onChange('type', e.target.value)}
                        fullWidth
                    />
                </Box>
            </DialogContent>

            <DialogActions sx={{ px: 3, py: 2 }}>
                <Button onClick={onReset} variant="outlined">
                    Reset
                </Button>
                <Button onClick={onClose} variant="outlined">
                    Cancel
                </Button>
                <Button variant="contained" onClick={onApply}>
                    Apply
                </Button>
            </DialogActions>
        </Dialog>
    );
}